import React from "react";
// i18n
// scroll bar
import "simplebar-react/dist/simplebar.min.css";
// map
import "src/utils/mapboxgl";
import "mapbox-gl/dist/mapbox-gl.css";
// editor
import "react-quill/dist/quill.snow.css";
// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";
// context
// import { SettingsProvider } from "src/context/settings";
// redux
import ReduxProvider from "src/redux/redux-provider";
// routes
import { NavigationProvider } from "src/routes/context";
import Router from "src/routes/sections";
import ArcoThemeProvider from "src/theme-arco";
// hooks
import useMeta from "src/hooks/use-meta";
// import useGTM from "src/hooks/use-gtm";
import useChunkLoad from "src/hooks/use-chunk-load";
import { useScrollToTop } from "src/hooks/use-scroll-to-top";
// components
// import MotionLazy from "src/components/animate/motion-lazy";
// auth
import { AuthConsumer, AuthProvider } from "src/auth/context/jwt";

// ----------------------------------------------------------------------

export default function App() {
    useMeta();
    // useGTM();
    useChunkLoad();

    useScrollToTop();

    // ----------------------------------

    return (
        <NavigationProvider>
            <AuthProvider>
                <ReduxProvider>
                    <ArcoThemeProvider locale="zh-CN">
                        {/* <MotionLazy> */}
                        <AuthConsumer>
                            <Router />
                        </AuthConsumer>
                        {/* </MotionLazy> */}
                    </ArcoThemeProvider>
                </ReduxProvider>
            </AuthProvider>
        </NavigationProvider>
    );
}
